import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Trans, useTranslation} from 'react-i18next';
import SearchBar from '../../../../../../components/search-bar';
import {upperCaseFirstLetter} from '../../../../../../utils';
import Avatar from '../../../../../../components/avatar';
import Icon from '../../../../../../components/icon';
import Loader from '../../../../../../components/sprite/components/loader';
import {
	enteredModalContactSearchValue as setEnteredModalContactSearchValue,
	findMyContacts as setFindMyContacts,
	isSearchingContacts as setIsSearchingContacts, modalContactSearchResult as setModalContactSearchResult,
	putLabelToAdd,
	selectContactToAdd, stopFindingNextMyContacts as setStopFindingNextMyContacts
} from '../../../../../../../actions/contactActions';
import './index.css';
import NewContactsLoading
	from '../../../list-of-contacts/components/list-of-contacts-body/components/list-of-contacts-body-content/components/new-contacts-loading';

function AddExistingContactToLabelPopup () {

	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(false);
	const [currentSelectedContact, setCurrentSelectedContact] = useState([]);
	const [scrollTop, setScrollTop] = useState(0);
	const [viewportHeight, setViewportHeight] = useState(0);
	const [filteredMyContacts, setFilteredMyContacts] = useState(null);

	const selectedContactsGroup = useSelector( state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const isSearchingContacts = useSelector( state => state.contactReducer.isSearchingContacts);
	const enteredModalContactSearchValue = useSelector( state => state.contactReducer.enteredModalContactSearchValue);
	const modalContactSearchResult = useSelector( state => state.contactReducer.modalContactSearchResult);
	const findMyContacts = useSelector( state => state.contactReducer.findMyContacts);
	const findContacts = useSelector( state => state.contactReducer.findContacts);
	const myContactsPageSize = useSelector( state => state.contactReducer.myContactsPageSize);
	const stopFindingNextMyContacts = useSelector( state => state.contactReducer.stopFindingNextMyContacts);

	const dispatch = useDispatch();

	const rowHeight = 72;
	const amountRowsBuffered = 2;

	useEffect(() => {
		setViewportHeight(document.querySelector('.list-of-group-body').getBoundingClientRect().height);
		dispatch(setFindMyContacts(myContactsPageSize));
	}, [dispatch, myContactsPageSize]);

	useEffect(() => {
		if(findMyContacts){
			setFilteredMyContacts(findMyContacts.contacts.filter(item => findContacts.contacts.map(contact => contact.id).includes(item.id) === false).map((item, index) => {
				return (
					{
						...item,
						position: index + 1
					}
				)
			}))
		}
	},[findContacts, findMyContacts]);

	useEffect(() => {
		if(stopFindingNextMyContacts === true){
			dispatch(setStopFindingNextMyContacts(false))
		}
	}, [dispatch, stopFindingNextMyContacts]);

	const proceed = (e) => {
		e.preventDefault();

		setIsLoading(true);

		/*
		* Push contacts to add
		* */

		if (currentSelectedContact.length > 0 ) {
			dispatch(selectContactToAdd(currentSelectedContact));
			dispatch(putLabelToAdd([selectedContactsGroup], currentSelectedContact, false, selectedContactsGroup.name));
		}
	};

	const selectAllContacts = (e) => {
		let cTarget = e.currentTarget;

		if(cTarget.checked === true){

			let selectedContactsArray = [];

			if(modalContactSearchResult && modalContactSearchResult.contacts.length > 0){
				modalContactSearchResult.contacts.filter((item) => findContactsFromSelectedLabel.includes(item.id) === false).forEach((contact) => {
					selectedContactsArray = selectedContactsArray.concat({
						'id': contact.id,
						'type':  contact.type
					});
				});
			} else {
				findMyContacts.contacts.filter((item) => findContactsFromSelectedLabel.includes(item.id) === false).forEach((contact) => {
					selectedContactsArray = selectedContactsArray.concat({
						'id': contact.id,
						'type':  contact.type
					});
				});
			}


			/*document.querySelectorAll(".list-of-contacts-content input[type='checkbox']").forEach(item => {

				if(item.checked === false){
					item.checked = true;
					selectedContactsArray = selectedContactsArray.concat({
						'id': item.dataset.id,
						'type':  item.dataset.type ? item.dataset.type : 'contact'
					});
				}
			});*/



			setCurrentSelectedContact(selectedContactsArray);

		} else {
			document.querySelectorAll(".list-of-contacts-content input[type='checkbox']").forEach(item => {
				if(item.checked === true){
					item.checked = false;
				}
			});

			setCurrentSelectedContact([]);
		}
	};

	const handleChange = (e) => {
		dispatch(setIsSearchingContacts(true));
		if(currentSelectedContact.length > 0){
			setCurrentSelectedContact([]);
		}
		if(document.getElementById("massContactsSelection").checked){
			document.getElementById("massContactsSelection").checked = false;
		}
		dispatch(setEnteredModalContactSearchValue(e.currentTarget.value));
		dispatch(setModalContactSearchResult(e.currentTarget.value));
	};

	const selectContact = (e) => {
		let cTarget = e.currentTarget;

		if(cTarget.checked){

			/*
			* Add to selected contact if exists
			* */

			setCurrentSelectedContact([
				...currentSelectedContact,
				{
					'id': cTarget.dataset.id,
					'type':  cTarget.dataset.type ? cTarget.dataset.type : 'contact'
				}
			]);

		} else {

			/*
			* Remove from selected contact if exists
			**/



			setCurrentSelectedContact([
				...currentSelectedContact.filter(item => item.id !== cTarget.dataset.id)
			]);

		}
	};

	const update = (e) => {
		setScrollTop(e.target.scrollTop);
	};

	let findContactsFromSelectedLabel = findContacts.contacts.map(item => item.id);

	let totalRows =
		modalContactSearchResult
		?
			modalContactSearchResult.contacts.length > 0
			?
				modalContactSearchResult.contacts.length
			:
				enteredModalContactSearchValue !== "" // To display "No contact found"
				?
					1
				:
					filteredMyContacts
					?
						filteredMyContacts.length
					:
						3 // To display the loader
		:
			filteredMyContacts
			?
				filteredMyContacts.length
			:
				3; // To display the loader

	let indexStart = Math.max(
		Math.floor(scrollTop / rowHeight) - amountRowsBuffered,
		0
	);

	let indexEnd = Math.min(
		Math.ceil((scrollTop + viewportHeight) / rowHeight - 1) +
		amountRowsBuffered,
		totalRows - 1
	);

	return (
		<div className="add-existing-contact-to-label-popup">
			<form method="post" onSubmit={proceed}>
				<div className="modal-header justify-content-start pt-4">
					<h2 className="m-0"><strong>{selectedContactsGroup.name}</strong><small className="ml-1"><em>({t("selectPopupText1")})</em></small></h2>
				</div>
				<div className="modal-body bg-light">
					<div className="list-of-contacts-columns d-flex align-items-center no-gutters border-bottom">
						<div className="col-7 d-flex align-items-center">
							<div className="custom-control custom-checkbox my-1 mr-sm-2">
								<input onClick={selectAllContacts} type="checkbox" className="custom-control-input" id="massContactsSelection"/>
								<label className="custom-control-label" htmlFor="massContactsSelection"/>
							</div>
							{t("headerSelectAllText")}
						</div>
						<div className="col-5">
							<SearchBar
								id="addToLabelSearchContact"
								label="Search a contact"
								title={t("textSearchContact")}
								srOnly={true}
								onChange={handleChange}
								placeholder={upperCaseFirstLetter(t("textSearchContact"))}
								width={226}
							/>
						</div>
					</div>
					{/*
                            this.props.enteredContactSearchValue && !this.props.confirmContactResearch
                                ?
                                <ContactsResult/>
                                :
                                null
                        */}
					<div className="list-of-contacts-content" onScroll={ update }>
						<div style={{
							position: 'relative',
							height: rowHeight * totalRows,
							overflowX: 'hidden'
						}}>
							{
								isSearchingContacts === false
								?
									enteredModalContactSearchValue !== "" && modalContactSearchResult.contacts.length > 0
									?
										modalContactSearchResult.contacts.map(item => (
											<div
												key={item.id}
												className="d-flex align-items-center no-gutters py-2"
												style={{
													position: 'absolute',
													height: rowHeight,
													top: item.position * rowHeight - rowHeight,
													width: '100%'
												}}
											>
												<div className="d-flex align-items-center col-8">
													<div className="custom-control custom-checkbox">
														<input
															type="checkbox"
															data-id={item.id}
															data-name={item.name}
															data-type={item.type}
															onChange={selectContact}
															className="custom-control-input"
															id={`label-checkbox-${item.id}`}
															checked={JSON.stringify(currentSelectedContact).includes(item.id)}
														/>
														<label className="custom-control-label" htmlFor={`label-checkbox-${item.id}`}/>
													</div>
													{
														item.hasImage
															?
															<Avatar size={36} className="mr-3 border-0" src={`data:image/png;base64,${item.picture}`}/>
															:
															<Avatar size={36} className="mr-3 border-0" src={item.picture}/>
													}
													<div>
														{item.name ? <p><strong>{item.name}</strong></p> : ''}
														{item.email ? <p>{item.email}</p> : ''}
													</div>
												</div>
												<div className="col-4">
													{item.phoneNumber ? <p>{item.phoneNumber}</p> : ''}
													{item.jobTitle ? <p>{item.jobTitle}</p> : ''}
													{item.company ? <p>{item.company}</p> : ''}
												</div>
											</div>
										))
									:
										enteredModalContactSearchValue !== ""
										?
											<div className="p-3">{t("noContactText")}.</div>
										:
											filteredMyContacts !== null
											?
												filteredMyContacts.length > 0
													?
													filteredMyContacts.slice(indexStart, indexEnd + 1).map( contact => {

														return (
															<div
																key={contact.id}
																className="d-flex align-items-center no-gutters py-2"
																style={{
																	position: 'absolute',
																	height: rowHeight,
																	top: (contact.position) * rowHeight - rowHeight,
																	width: '100%'
																}}
															>
																<div className="d-flex align-items-center col-8">
																	<div className="custom-control custom-checkbox">
																		<input
																			type="checkbox"
																			data-id={contact.id}
																			data-name={contact.name}
																			data-type={contact.type}
																			onChange={selectContact}
																			className="custom-control-input"
																			id={`label-checkbox-${contact.id}`}
																			checked={JSON.stringify(currentSelectedContact).includes(contact.id)}
																		/>
																		<label className="custom-control-label" htmlFor={`label-checkbox-${contact.id}`}/>
																	</div>
																	{
																		contact.hasImage
																			?
																			<Avatar size={36} className="mr-3 border-0" src={`data:image/png;base64,${contact.picture}`}/>
																			:
																			<Avatar size={36} className="mr-3 border-0" src={contact.picture}/>
																	}
																	<div>
																		{contact.name ? <p><strong>{contact.name}</strong></p> : ''}
																		{contact.email ? <p>{contact.email}</p> : ''}
																	</div>
																</div>
																<div className="col-4">
																	{contact.phoneNumber ? <p>{contact.phoneNumber}</p> : ''}
																	{contact.jobTitle ? <p>{contact.jobTitle}</p> : ''}
																	{contact.company ? <p>{contact.company}</p> : ''}
																</div>
															</div>
														)

													})
													:
													<p className="py-3">{t("noContactText")}.</p>
											:
												<Loader/>
								:
									<div className="py-3">
										<Icon animated={'pulse'} name="spinner"/>
									</div>
							}
						</div>
					</div>
					{
						findMyContacts
						&& findMyContacts.contacts.length < findMyContacts.pages.totalRecords
						&& <NewContactsLoading contacts={findMyContacts}/>
					}

				</div>
				<div className="modal-footer p-3">
					{
						isLoading === false ?
							currentSelectedContact.length === 0
								?
								<button type="submit" disabled={true} className="btn btn-primary">{t("textAddToContactList")}</button>
								:
								currentSelectedContact.length === 1
									?
									<button type="submit" disabled={false} className="btn btn-primary">{t("textAddToContactList")}</button>
									:
									<button type="submit" disabled={false} className="btn btn-primary"><Trans i18nKey="textAddExistingContactToLabelPopup" values={{SelectedContactlength: currentSelectedContact.length }} /> </button>
							:
							<button type="submit" disabled={true} className="btn btn-primary">
								<Icon animated={'pulse'} name="spinner"/>
							</button>
					}

				</div>
			</form>
		</div>
	);
}

export default AddExistingContactToLabelPopup;
